export default "__VITE_ASSET__BX23nZDd__"